import { v4 as uuidv4 } from "uuid"
import { isProductionEnvironment } from "@/helper/app/browser-helper.ts"

export default class GlobalsService {
  private static _instance: GlobalsService

  public static getInstance() {
    if (!this._instance) {
      this._instance = new GlobalsService()

      // Outside production, hand the singleton to the page so an end-to-end test can learn this
      // session's uuid. SocketService drops publications whose `sender` matches it, and a test
      // cannot prove that filter works without being able to forge a message that claims this
      // exact identity. Same escape hatch, and same reasoning, as `__socketService`.
      //
      // Nothing is exposed that page scripts could not already reach by importing the module.
      if (!isProductionEnvironment() || import.meta.env.VITE_PLAYWRIGHT_TEST_HOOKS === "true") {
        ;(window as unknown as Record<string, unknown>).__globalsService = this._instance
      }
    }
    return this._instance
  }

  private readonly sessionUUID: string

  private constructor() {
    this.sessionUUID = uuidv4()
  }

  public getMySessionUUID() {
    return this.sessionUUID
  }
}
